import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Car } from "lucide-react";
import { api } from "../../lib/api";
import { Skeleton } from "./_shared";

/* ---------------- Driver Rentals ---------------- */
export default function DriverRentalsTab() {
  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => {
    setLoading(true);
    api.get("/admin/driver-rentals")
      .then((r) => setRentals(r.data))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);
  const act = async (r, action) => {
    try {
      await api.post(`/admin/driver-rentals/${r.id}/${action}`);
      toast.success(action === "activate" ? "Activated" : "Completed");
      load();
    } catch (e) { toast.error("Failed"); }
  };
  if (loading) return <Skeleton />;
  if (rentals.length === 0) return <div className="glass rounded-3xl p-10 text-center text-white/60">No driver rentals yet.</div>;
  return (
    <div className="space-y-3" data-testid="bo-dr-list">
      {rentals.map((r) => (
        <div key={r.id} data-testid={`bo-dr-${r.id}`}
          className="glass rounded-2xl p-5 grid md:grid-cols-[1fr_auto] gap-4 items-start">
          <div>
            <div className="flex items-center gap-2 mb-1 flex-wrap">
              <span className="label-caps px-2 py-0.5 rounded-full bg-cream/10 border border-cream/30 text-cream">{r.status}</span>
              {r.autopay_enabled && (
                <span className="label-caps px-2 py-0.5 rounded-full bg-white/5 border border-white/10 text-white/60">AutoPay</span>
              )}
            </div>
            <div className="font-serif text-lg">{r.vehicle_name}</div>
            <div className="text-sm text-white/60 mt-1">
              {r.driver?.name || r.application?.full_legal_name} · {r.driver?.email || "no email"}
            </div>
            <div className="text-sm text-white/50 mt-1">
              Weekly ${r.weekly_rate?.toFixed(2)} · {r.weeks_paid} paid / {r.weeks_committed} weeks
              · Deposit ${r.deposit?.toFixed(2)}
            </div>
            {r.application?.rideshare_platforms?.length > 0 && (
              <div className="text-xs text-white/40 mt-1">Platforms: {r.application.rideshare_platforms.join(", ")}</div>
            )}
          </div>
          <div className="flex flex-col items-end gap-1">
            <div className="font-serif text-xl text-cream">${r.balance_paid?.toFixed(2) || "0.00"}</div>
            <div className="text-xs text-white/40">paid</div>
            <div className="flex gap-1 mt-2 flex-wrap justify-end">
              {r.status === "pending_deposit" && (
                <button onClick={() => act(r, "activate")}
                  className="px-2 py-1 rounded-full text-xs border border-cream/30 hover:bg-cream/10 text-cream">
                  Mark active
                </button>
              )}
              {r.status !== "completed" && (
                <button onClick={() => act(r, "complete")}
                  className="px-2 py-1 rounded-full text-xs border border-white/10 hover:border-white/30">
                  Complete
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

